<template>
  <div>
    <Subtitle
      style="cursor: pointer; word-break: break-word"
      :text="getContextNameLong(viewContext, post.creator)"
      :font-weight="700"
      @click="goToProfile"
      class="mb-0"
    />
    <RelativeTime v-if="!!post.created_at" :date-time="post.created_at" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { Post } from "suus-api"
import { getContextNameLong, ViewContext } from "concerns/useContextName"
import Subtitle from "components/UI/Subtitle.vue"
import { goToUrl } from "helpers/navigation"
import RelativeTime from "components/UI/RelativeTime.vue"

export default defineComponent({
  name: "PostHeader",
  methods: { getContextNameLong },
  components: { RelativeTime, Subtitle },
  props: {
    post: {
      type: Object as PropType<Post>,
      required: true,
    },
    viewContext: {
      type: Object as PropType<ViewContext>,
    },
  },
  setup(props) {
    const goToProfile = () => {
      if (props.post.creator.url) goToUrl(props.post.creator.url)
    }
    return {
      goToProfile,
    }
  },
})
</script>
